import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

export interface DialogButton {
	matDialogClose: any;
	term: string;
	confirm?: boolean;
}

@Component({
	selector: 'rx-awareness-popup-layout',
	templateUrl: './awareness-popup-layout.component.html',
	styleUrls: ['./awareness-popup-layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AwarenessPopupLayoutComponent {
	@Input()
	buttons: DialogButton[];

	constructor(private readonly dialogRef: DialogRef) {}

	close(value: any): void {
		this.dialogRef.close(value);
	}
}
